import { render } from "./BuildingGrid.vue?vue&type=template&id=55d0fa44"
import script from "./BuildingGrid.vue?vue&type=script&lang=js"
export * from "./BuildingGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__